<template>
  <v-card outlined class="mx-auto mt-0 s-layout-small">
    <v-card-title class="pa-0">
      <p class="mb-0">Địa chỉ nhận hàng</p>
    </v-card-title>
    <div class="mt-4" style="min-height: 480px;">
      <validation-provider v-slot="{ errors }" name="Tên người nhận" rules="required|max:255">
        <v-text-field
          v-model="shippingAddress.receiver"
          :readonly="isReadOnly"
          label="Tên người nhận"
          :error-messages="errors"
          color="primary"
        />
      </validation-provider>
      <div class="d-flex align-center">
        <validation-provider
          v-slot="{ errors }"
          name="Số Điện thoại"
          :rules="{ regex: regex.isVNPhoneMobile, required:true }"
          style="width: 100%"
        >
          <v-text-field
            v-model="shippingAddress.phone"
            :readonly="isReadOnly"
            label="Số Điện thoại"
            :error-messages="errors"
            color="primary"
          />
        </validation-provider>
        <v-tooltip v-if="showChat" bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              size="16"
              width="20"
              height="20"
              class="mr-1"
              icon
              small
              color="info"
              v-on="on"
            >
              <v-icon size="16">mdi-facebook-messenger</v-icon>
            </v-btn>
          </template>
          <span>Nhắn tin</span>
        </v-tooltip>
      </div>
      <validation-provider
        v-slot="{ errors }"
        name="Email"
        :rules="{ max:255, email: true, regex: regex.isEmail }"
      >
        <v-text-field
          v-model="shippingAddress.email"
          :readonly="isReadOnly"
          label="Email"
          :error-messages="errors"
          color="primary"
        />
      </validation-provider>
      <span>
        <label>Điạ chỉ</label>
        <v-row style="margin-top: -10px">
          <v-col cols="12" sm="6">
            <validation-provider v-slot="{ errors }" name="Tỉnh"
            :rules="['COD','BANK'].includes(contentOrder.paymentType) ? 'required' : ''"
            >
              <v-autocomplete
                v-model="shippingAddress.tinhId"
                :disabled="isReadOnly"
                :items="provinces"
                item-text="ten"
                item-value="id"
                label="Tỉnh"
                @change="onChangeProvince"
                :error-messages="errors"
                :filter="customFilterSearch"
              />
            </validation-provider>
          </v-col>
          <v-col cols="12" sm="6">
            <validation-provider
              v-slot="{ errors }"
              name="Quận/Huyện"
              :rules="['COD','BANK'].includes(contentOrder.paymentType) ? 'required' : ''"
            >
              <v-autocomplete
                v-model="shippingAddress.huyenId"
                :disabled="isReadOnly"
                :items="districts"
                item-text="ten"
                item-value="id"
                label="Quận/Huyện"
                @change="onChangeDistrict"
                :error-messages="errors"
                :filter="customFilterSearch"
              />
            </validation-provider>
          </v-col>
          <v-col cols="12" sm="12">
            <validation-provider
              v-slot="{ errors }"
              name="Phường/Xã"
              :rules="['COD','BANK'].includes(contentOrder.paymentType) ? 'required' : ''"
            >
              <v-autocomplete
                @change="onChangeWard"
                v-model="shippingAddress.xaId"
                :disabled="isReadOnly"
                label="Phường/Xã"
                :items="wards"
                item-text="ten"
                item-value="id"
                :error-messages="errors"
                :filter="customFilterSearch"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </span>
      <validation-provider
        v-slot="{ errors }"
        name="Địa chỉ chi tiết(số nhà, đường, thôn...)"
        :rules="['COD','BANK'].includes(contentOrder.paymentType) ? 'required|max:255' : ''"
      >
        <v-textarea
          label="Địa chỉ chi tiết(số nhà, đường, thôn...)"
          rows="3"
          :error-messages="errors"
          v-model="shippingAddress.detailAddress"
          :readonly="isReadOnly"
        />
      </validation-provider>
    </div>
  </v-card>
</template>

<script>
import { regex } from '../../../helpers/constants';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const AddressRepository = RepositoryFactory.get('address');
export default {
  props: {
    shippingAddress: {
      type: Object,
      default: () => {}
    },
    provinces: {
      type: Array,
      default: () => []
    },
    showChat: {
      type: Boolean,
      default: false
    },
    contentOrder: {
      type: Object,
      default: () => {}
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      regex,
      districts: [],
      wards: [],
    };
  },
  created() {
    if (this.shippingAddress.tinhId == 0) {
      this.shippingAddress.tinhId = '';
    }
    if (this.shippingAddress.tinhId) {
      const dataTemp = this.provinces.find(
        data => data.id === this.shippingAddress.tinhId
      );
      this.shippingAddress.tinhName = _.get(dataTemp, 'ten', '');
      this.getDistricts();
    }
    if (this.shippingAddress.huyenId) {
      this.getWards();
    }
  },
  methods: {
    onChangeWard() {
      const dataTemp = this.wards.find(
        data => data.id === this.shippingAddress.xaId
      );
      this.shippingAddress.xaName = _.get(dataTemp, 'ten', '') + ', ';
    },
    onChangeDistrict() {
      if (this.shippingAddress.huyenId) {
        this.shippingAddress.xaId = '';
        this.wards = [];
        this.getWards();
        const dataTemp = this.districts.find(
          data => data.id === this.shippingAddress.huyenId
        );
        this.shippingAddress.huyenName = _.get(dataTemp, 'ten', '') + ', ';
        this.shippingAddress.xaName = '';
      }
    },
    onChangeProvince() {
      // if (this.shippingAddress.tinhId) {
      this.shippingAddress.huyenId = '';
      this.shippingAddress.xaId = '';
      this.districts = [];
      this.wards = [];
      this.getDistricts();
      const dataTemp = this.provinces.find(
        data => data.id === this.shippingAddress.tinhId
      );
      this.shippingAddress.tinhName = _.get(dataTemp, 'ten', '');
      this.shippingAddress.huyenName = '';
      this.shippingAddress.xaName = '';
      if (this.shippingAddress.tinhId == 0) {
        this.shippingAddress.huyenId = 0;
        this.shippingAddress.xaId = 0;
      }
    },
    async getDistricts() {
      const loader = this.$loading.show();
      const respond = await AddressRepository.districts(
        { limit: 100 },
        this.shippingAddress.tinhId
      );
      loader.hide();
      if (_.get(respond, 'success', false)) {
        this.districts = _.get(respond, 'data', []);
        if (this.shippingAddress.huyenId) {
          const dataTemp = this.districts.find(
            data => data.id === this.shippingAddress.huyenId
          );
          this.shippingAddress.huyenName = _.get(dataTemp, 'ten', '') + ', ';
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getWards() {
      const loader = this.$loading.show();
      const respond = await AddressRepository.wards(
        { limit: 100 },
        this.shippingAddress.tinhId,
        this.shippingAddress.huyenId
      );
      loader.hide();
      if (_.get(respond, 'success', false)) {
        this.wards = _.get(respond, 'data', []);
        if (this.shippingAddress.xaId) {
          const dataTemp = this.wards.find(
            data => data.id === this.shippingAddress.xaId
          );
          this.shippingAddress.xaName = _.get(dataTemp, 'ten', '') + ', ';
        }
        if (this.wards.length === 0) {
          this.shippingAddress.xaId = 0;
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
  }
};
</script>
